import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/uiComponents/components/ui/dialog";
import { Button } from "@/uiComponents/components/ui/button";

import { DeleteProps } from "@/types/organization";

const DeleteModal = <T,>({
  onClose,
  isOpen,
  item,
  onConfirm,
  itemLabel = "item",
}: DeleteProps<T>) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Delete {itemLabel}?</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete this {itemLabel}? This action cannot
            be undone.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            className="cursor-pointer  bg-[#191F29] text-white hover:bg-[#191F29] hover:text-white"
            variant="outline"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            className="cursor-pointer"
            variant="destructive"
            onClick={() => {
              onConfirm(item);
              onClose();
            }}
          >
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteModal;
